'use client';

import { usePageLoader } from '@/hooks/usePageLoader';
import { useSnackbar } from '@/hooks/useSnackbar';
import { getIbowClientForPasswordReset } from '@/init/ibowClient';
import {
  ResetPasswordResolver,
  ResetPasswordType,
} from '@/schemas/ResetPasswordSchema';
import { useForm } from 'react-hook-form';

type LogicProps = {
  tmpToken: string;
};

export const useLogic = ({ tmpToken }: LogicProps) => {
  const { setLoading } = usePageLoader();
  const { openSnackbar } = useSnackbar();
  const { control, handleSubmit } = useForm<ResetPasswordType>({
    resolver: ResetPasswordResolver,
    defaultValues: {
      password: '',
      confirm_password: '',
    },
  });

  const onClickSubmit = handleSubmit((data) => {
    setLoading(true);
    const ibowClient = getIbowClientForPasswordReset(tmpToken);
    ibowClient.authentication
      .postChangePassword({
        body: data,
      })
      .then(() => {
        window.location.href = '/signin';
      })
      .catch((err) => {
        if (err && err.status == 401) {
          openSnackbar(
            '有効期限が切れました。初めからやり直してください。',
            'error',
          );
        } else {
          openSnackbar(err.body.message, 'error');
        }
        setLoading(false);
      });
  });

  return { control, onClickSubmit };
};
